import { useMemo } from "react"
import { Settings, type ISettingsParsed } from "../Types/Generated/LogbookModel/Settings"
import type { DataStore } from "./Store"
import { SettingsApi } from "../Types/Generated/LogbookApi/SettingsApi"
import type { ISettingsResponse } from "../Types/Generated/LogbookModel/Settings"
import { useDataStore } from "./Context"

export interface SettingsWriterIds {
  shipId: number;
}

export interface SettingsWriters {
  updateSettings: (values: object) => Promise<ISettingsResponse>;
  updateShipData: (values: object) => Promise<ISettingsResponse>;
}

export function createStoreSettingsWriters(store: DataStore, ids: SettingsWriterIds): SettingsWriters {
  return {
    updateSettings: (values) => store.mutate({
      request: (client) =>
        new SettingsApi(client).settings.update({ params: ids, body: { data: JSON.stringify(values) } }).call(),
      reconcile: (response) => ({ entities: { Settings: response.settings } }),
    }),
    updateShipData: (values) => store.mutate({
      request: (client) =>
        new SettingsApi(client).settings.updateData({ params: ids, body: { data: JSON.stringify(values) } }).call(),
      reconcile: (response) => ({ entities: { Settings: response.settings } }),
    }),
  };
}

export function useSettingsWriters(shipId: number): SettingsWriters {
  const store = useDataStore();
  return useMemo(() => createStoreSettingsWriters(store, { shipId }), [store, shipId]);
}

export function latestParsedSettings(response: ISettingsResponse): ISettingsParsed | undefined {
  const latest = response.settings.at(-1);
  return latest ? Settings.parse(latest) : undefined;
}
